export default "__VITE_ASSET__u_9JmcKA__"